export default __webpack_public_path__ + "static/media/dysonsphere.171a52ff.svg";